import * as Style from "../SavePlans/ActiveSavingPlansStyle"

type ActionIconProps = {
    iconName: string,
    onClick?: (event: any) => any,
    isSelected?: boolean,
    theme: any
}

export const ActionIcon = ({
    iconName,
    onClick,
    isSelected,
    theme
}: ActionIconProps) => {

const Component = isSelected ? Style.ActionIconsSelected : Style.ActionIcons
    
    return (
        <Component theme={theme} onClick={onClick}>
            <i className={`ms-Icon ms-Icon--${iconName}`}/>
        </Component>
    )
}

export default ActionIcon;